





















import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import CTabs from "./cTabs.vue";

@Component({
  name: "MyWork",
  components: {
    CTabs
  }
})
export default class MyWork extends Base {
  private timer: any = null;
  private listSource: any[] = [];
  private tabIndex = 0;
  private tabs: any[] = [
    { label: "待办", key: "daiban", count: 0, pendType: "1" },
    { label: "待阅", key: "daiyue", count: 0, pendType: "2" }
  ];

  private destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  private created() {
    this.tabsClick();
    this.getProcessCount();

    this.timer = setInterval(() => {
      this.getProcessList(false);
    }, 30000);
  }

  private tabsClick(e?: any) {
    if (e) {
      this.tabIndex = e.activeIndex;
    }

    this.getProcessList();
  }

  private getProcessCount() {
    // 获取待办数量
    this.$api
      .ProcessCount({
        pendType: "1",
        status: "2",
        receiverUserCode: this.currentUser.userNo
      })
      .then((res: Api.Response) => this.$set(this.tabs[0], "count", res.data));

    // 获取待阅数量
    this.$api
      .ProcessCount({
        pendType: "2",
        status: "2",
        receiverUserCode: this.currentUser.userNo
      })
      .then((res: Api.Response) => this.$set(this.tabs[1], "count", res.data));
  }

  private async getProcessList(clearList = true) {
    if (clearList) {
      this.listSource = [];
    }
    const res = await this.$api.ProcessList(this.processListParams);
    if (res && res.code === 200) {
      this.listSource = res.rows;
    }
  }

  private get processListParams() {
    const _return = {
      pageNum: 1,
      pageSize: 7,
      sortBy: "initiationTime",
      order: "desc",
      pendType: this.tabs[this.tabIndex].pendType,
      status: "2",
      receiverUserCode: this.currentUser.userNo
    };
    return _return;
  }

  private get tabsLabel() {
    return Array.from(this.tabs, (item: any) => {
      return `${item.label}(${item.count})`;
    });
  }
}
